import { createContext, Dispatch, SetStateAction } from 'react';

export interface ExportSettingsType {
  from: Date | null;
  to: Date | null;
  periodNumber: string;
  period: string;
  exportType: string;
  includeMetadata: boolean;
}

export const defaultExportSettings: ExportSettingsType = {
  from: null,
  to: null,
  periodNumber: '2',
  period: 'm',
  exportType: 'all',
  includeMetadata: false
};

export const ExportSettingsContext = createContext<{
  exportSettings: ExportSettingsType;
  setExportSettings: Dispatch<SetStateAction<ExportSettingsType>>;
}>({
  exportSettings: defaultExportSettings,
  setExportSettings: () => {}
});
